import styled from "styled-components";
export const AllActivitiesTabStyle = styled.div``;
